/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Fast_Cat_MatchInputs */

const en_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check that the email addresses match.`)
};

const id_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa apakah alamat email sudah sesuai.`)
};

const ms_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila semak bahawa alamat e-mel sepadan.`)
};

const ca_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegura't que les adreces coincideixen.`)
};

const cs_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontrolujte prosím, zda se e-mailové adresy shodují.`)
};

const da_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tjek venligst, at e-mailadresserne stemmer overens.`)
};

const de_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte prüfe, ob die E-Mail-Adressen übereinstimmen.`)
};

const et_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kntrollige, et e-posti aadressid oleks samad.`)
};

const es_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asegúrate de que los correos coincidan.`)
};

const fr_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez que les adresses correspondent.`)
};

const hr_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provjerite je li se e-mail adrese podudaraju.`)
};

const it_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assicurati che gli indirizzi inseriti corrispondano.`)
};

const lv_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdzu, pārbaudiet, vai e-pasta adreses sakrīt.`)
};

const lt_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patikrinkite, ar el. pašto adresai sutampa.`)
};

const hu_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, ellenőrizze, hogy az e-mail címek egyeznek-e.`)
};

const nl_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer of de e-mailadressen overeenkomen.`)
};

const nb_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sørg for at e-postadressene er like.`)
};

const pl_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź, czy adresy e-mail są zgodne.`)
};

const pt_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique se inseriu o mesmo endereço de e-mail.`)
};

const ro_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te rugăm să verifici dacă adresele de e-mail se potrivesc.`)
};

const sk_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontrolujte, či sa emailové adresy zhodujú.`)
};

const sl_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preverite, ali se e-naslova ujemata.`)
};

const fi_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista, että sähköpostiosoitteet vastaavat toisiaan.`)
};

const sv_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollera att e-postadresserna stämmer överens.`)
};

const vi_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng kiểm tra xem các địa chỉ email có khớp nhau.`)
};

const tr_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen e-posta adreslerinin eşleştiğini kontrol edin.`)
};

const el_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελέγξτε ότι οι διευθύνσεις email ταιριάζουν.`)
};

const bg_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, провери дали имейл адресите съвпадат.`)
};

const ru_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, проверьте, что адреса электронной почты совпадают.`)
};

const sr_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверите да ли се поклапају имејл адресе.`)
};

const uk_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь ласка, перевірте, чи збігаються адреси електронної пошти.`)
};

const ka_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გთხოვთ, შეამოწმოთ, რომ ელექტრონული ფოსტის მისამართები ემთხვევა.`)
};

const hi_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया चेक करें की ईमेल एड्रेस मैच हो रहा है।`)
};

const th_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรุณาตรวจสอบให้แน่ใจว่าที่อยู่อีเมลตรงกัน`)
};

const ko_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소가 일치하는지 확인하세요.`)
};

const zh_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查电子邮件地址是否一致。`)
};

const zh_tw_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請檢查電子郵件地址是否相符。`)
};

const ja_quick_fast_cat_match = /** @type {(inputs: Quick_Fast_Cat_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスが一致していることを確認してください。`)
};

/**
* | output |
* | --- |
* | "Please check that the email addresses match." |
*
* @param {Quick_Fast_Cat_MatchInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const quick_fast_cat_match = /** @type {((inputs?: Quick_Fast_Cat_MatchInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Fast_Cat_MatchInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_quick_fast_cat_match(inputs)
	if (locale === "ms") return ms_quick_fast_cat_match(inputs)
	if (locale === "ca") return ca_quick_fast_cat_match(inputs)
	if (locale === "cs") return cs_quick_fast_cat_match(inputs)
	if (locale === "da") return da_quick_fast_cat_match(inputs)
	if (locale === "de") return de_quick_fast_cat_match(inputs)
	if (locale === "et") return et_quick_fast_cat_match(inputs)
	if (locale === "es") return es_quick_fast_cat_match(inputs)
	if (locale === "fr") return fr_quick_fast_cat_match(inputs)
	if (locale === "hr") return hr_quick_fast_cat_match(inputs)
	if (locale === "it") return it_quick_fast_cat_match(inputs)
	if (locale === "lv") return lv_quick_fast_cat_match(inputs)
	if (locale === "lt") return lt_quick_fast_cat_match(inputs)
	if (locale === "hu") return hu_quick_fast_cat_match(inputs)
	if (locale === "nl") return nl_quick_fast_cat_match(inputs)
	if (locale === "nb") return nb_quick_fast_cat_match(inputs)
	if (locale === "pl") return pl_quick_fast_cat_match(inputs)
	if (locale === "pt") return pt_quick_fast_cat_match(inputs)
	if (locale === "ro") return ro_quick_fast_cat_match(inputs)
	if (locale === "sk") return sk_quick_fast_cat_match(inputs)
	if (locale === "sl") return sl_quick_fast_cat_match(inputs)
	if (locale === "fi") return fi_quick_fast_cat_match(inputs)
	if (locale === "sv") return sv_quick_fast_cat_match(inputs)
	if (locale === "vi") return vi_quick_fast_cat_match(inputs)
	if (locale === "tr") return tr_quick_fast_cat_match(inputs)
	if (locale === "el") return el_quick_fast_cat_match(inputs)
	if (locale === "bg") return bg_quick_fast_cat_match(inputs)
	if (locale === "ru") return ru_quick_fast_cat_match(inputs)
	if (locale === "sr") return sr_quick_fast_cat_match(inputs)
	if (locale === "uk") return uk_quick_fast_cat_match(inputs)
	if (locale === "ka") return ka_quick_fast_cat_match(inputs)
	if (locale === "hi") return hi_quick_fast_cat_match(inputs)
	if (locale === "th") return th_quick_fast_cat_match(inputs)
	if (locale === "ko") return ko_quick_fast_cat_match(inputs)
	if (locale === "zh") return zh_quick_fast_cat_match(inputs)
	if (locale === "zh-tw") return zh_tw_quick_fast_cat_match(inputs)
	if (locale === "ja") return ja_quick_fast_cat_match(inputs)
	return en_quick_fast_cat_match(inputs)
});